import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { EmptyState } from '../ui/components/EmptyState.js';
import '../ui/components/button.css';
import { PublicLayout } from './layouts/PublicLayout.js';

/** The page for any path no route matches. Its `<h1>` names the problem plainly. */
export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <PublicLayout>
      <EmptyState
        level={1}
        title={t('notFound.title')}
        actions={
          <Link to="/" className="btn btn--primary pressable">
            {t('notFound.home')}
          </Link>
        }
      >
        {t('notFound.body')}
      </EmptyState>
    </PublicLayout>
  );
}

/** Shown if a page fails to render: plain words and a way home, never a stack trace. */
export function ErrorPage() {
  const { t } = useTranslation();
  return (
    <PublicLayout>
      <EmptyState
        level={1}
        title={t('crash.title')}
        actions={
          <a href="/" className="btn btn--primary pressable">
            {t('notFound.home')}
          </a>
        }
      >
        {t('crash.body')}
      </EmptyState>
    </PublicLayout>
  );
}
